import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type { UserPermissionsContext } from 'bundles/user-permissions/src/utils/types';

/**
 * @deprecated Prefer the hook-based access in [UserPermissionsDataContext](https://github.com/webedx-spark/web/blob/main/static/bundles/user-permissions/src/UserPermissionsDataContext.tsx)
 */
export const withUserPermissions =
  <P extends UserPermissionsContext>() =>
  (WrappedComponent: React.ComponentType<P>) => {
    return class Wrapper extends React.Component<P> {
      static displayName = `withUserPermissions(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      static contextTypes = {
        userPermissions: PropTypes.object,
      };

      declare context: LegacyContextType<typeof Wrapper.contextTypes>;

      render() {
        return <WrappedComponent {...this.props} userPermissions={this.context.userPermissions} />;
      }
    };
  };

export default withUserPermissions;
